import { useState, useEffect, useMemo } from "react";
import {
  getOnBoardingRule,
  isCRMMember,
  queryCRMStatus,
  registerCRM,
  queryCRMSwitch,
} from "@/apis";
import { setLoading } from "@/store/slices/feedback";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import CRMAlert from "@/components/CRMAlert";

const useCRM = (merchantId, type) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isHasLoyalty, setIsHasLoyalty] = useState(false);
  const [isSwitchOpen, setIsSwitchOpen] = useState(false);
  const [isHasOnBoardingRule, setIsHasOnBoardingRule] = useState(false);
  const [onBoardingRule, setOnBoardingRule] = useState({});
  const [isFirstLoad, setIsFirstLoad] = useState(false);

  const isFullWidth = useMemo(() => {
    return type === "front";
  }, [type]);

  useEffect(() => {
    const checkIsCRMOpen = async () => {
      try {
        dispatch(setLoading(true));
        const res = await queryCRMStatus({ merchantId });
        if (res.status === 200 && res.data.success) {
          const { loyaltyProgram } = res.data.result?.[0];
          setIsHasLoyalty(loyaltyProgram);
        }
      } catch (e) {
        // Message.error({ content: e.message });
      } finally {
        dispatch(setLoading(false));
      }
    };
    checkIsCRMOpen();
  }, []);

  useEffect(() => {
    const checkIsSwitch = async () => {
      try {
        dispatch(setLoading(true));
        const res = await queryCRMSwitch({ merchantId });
        if (res.status === 200 && res.data.success) {
          const config = res.data.result?.[0];
          const openSwitchLines = config?.crmConfig?.eligibleProductLines;
          setIsSwitchOpen(openSwitchLines?.includes("WAITING_LIST"));
        }
      } catch (e) {
        // Message.error({ content: e.message });
      } finally {
        dispatch(setLoading(false));
      }
    };
    checkIsSwitch();
  }, []);

  const isCRMOpen = useMemo(() => {
    return isHasLoyalty && isSwitchOpen;
  }, [isHasLoyalty, isSwitchOpen]);

  useEffect(() => {
    const onBoardingRuleInfo = async () => {
      try {
        dispatch(setLoading(true));
        const res = await getOnBoardingRule(merchantId);
        if (res.status === 200 && res.data.success) {
          setOnBoardingRule(res.data.result?.[0] || {});
          setIsHasOnBoardingRule(res.data.result?.length > 0);
        }
      } catch (e) {
        // Message.error({ content: e.message });
      } finally {
        dispatch(setLoading(false));
        setIsFirstLoad(true);
      }
    };
    onBoardingRuleInfo();
  }, []);

  const checkCRMMember = async (phone) => {
    try {
      dispatch(setLoading(true));
      const data = {
        merchantId,
        phone: `+1${phone.replace(/\D/g, "")}`,
      };
      const res = await isCRMMember(data);
      if (res.status === 200) {
        // false -> 无会员信息， true-> 有会员信息
        return res.data.success;
      }
    } catch (e) {
      CRMAlert.error({ isFullWidth });
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handleConfirmCRM = async ({ phone, name }, onSuccessEffect) => {
    try {
      dispatch(setLoading(true));
      const data = {
        merchantId,
        phone: `+1${phone.replace(/\D/g, "")}`,
        firstname: name,
        joinChannel: "WAITLIST",
      };
      const res = await registerCRM(data);
      if (res.status === 200 && res.data.success) {
        CRMAlert.success({ isFullWidth });
        onSuccessEffect?.();
      }
    } catch (e) {
      CRMAlert.error({ isFullWidth });
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handleSkipCRM = (id, mode) => {
    let src = `/${merchantId}/${type}/waitingNumber?id=${id}`;
    if (mode) {
      src = `${src}&mode=${mode}`;
    }
    navigate(src);
  };

  return {
    isCRMOpen,
    isHasOnBoardingRule,
    onBoardingRule,
    checkCRMMember,
    handleConfirmCRM,
    handleSkipCRM,
    isFirstLoad,
  };
};

export default useCRM;
